// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_eo-7";
export var emphasizeQuantity = "_eo-3";
export var flatBottomCorners = "_eo-5";
export var productImage = "_eo-0";
export var quantityContainer = "_eo-2";
export var quantityHeader = "_eo-6";
export var tooltip = "_eo-1";
export var wrapAndEllipsesOverflow = "_eo-4";